import { Box, Button, HStack } from "@chakra-ui/react";
import React, { useState } from "react";
import { QuestionsLayout } from "../../../components/molecules/questionLayouts/QuestionsLayout";
import { usePractice } from "../../../context/PracticeContext";
import pkg from "@inrscr/coschool-ui-components";
import Assistant from "../../../components/molecules/ai-tutor/Assistant/Assistant";
import AssistantImg from "../../../assets/ai-tutor/assistant.svg";
import CorrectAnsImg from "../../../assets/ai-tutor/correct_answer.svg";

export default function DescriptiveAnswer() {
  const { displayedQues, currentQuesIndex, descriptiveAnswer = {}, chatHistory } = usePractice();
  const { DescriptiveAnswer: DescriptiveAnswerUI, TranscriptionImagePreview, User } = pkg;
  const [openModal, setOpenModal] = useState(false);
  const question = displayedQues?.[currentQuesIndex];
  const currentChat = chatHistory?.[currentQuesIndex] || [];
  const showLoader = Object.keys(descriptiveAnswer || {})?.length == 0 && currentChat?.length > 0;
  const { descImageList = [] } = currentChat?.[0] || {};
  return (
    <Box>
      {question && (
        <QuestionsLayout
          questionObject={question}
          onAnswerChanged={() => { }}
          isFactualBasket={false}
          isAnswerSubmitted={true}
        />
      )}

      {currentChat?.[0]?.content && showLoader &&
        <User
          text={currentChat?.[0]?.content}
          transcribeImageList={descImageList}
          onPreview={() => {
            setOpenModal(true)
          }}
          isTutor={true}
        />
      }
      {Object.keys(descriptiveAnswer || {})?.length > 0 && (
        <DescriptiveAnswerUI
          loader={false}
          icons={{
            AssistantImg: AssistantImg,
            CorrectAnsImg: CorrectAnsImg,
          }}
          user_query={currentChat?.[0]?.content}
          question={question}
          assistantObj={descriptiveAnswer}
        />
      )}
      {showLoader && <Assistant loader={true} />}
      {openModal &&
        <TranscriptionImagePreview
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          transcribeImageList={descImageList}
        />
      }
    </Box>
  );
}
